export default "__VITE_ASSET__c7a3bfb8__"